import React, { useState } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@mui/styles';
import { Card, CardContent, Divider, Grid2, Typography } from '@mui/material';
import OptionSelectorSelector from './OptionSelector';
import CreateXMLTopologyFromFTPForm from './CreateXMLTopologyFromFTPForm';
import S12ThresholdsHistoryUpdateForm from './S12ThresholdsHistoryUpdateForm';
import VTKDataRefreshForm from './VTKDataRefreshForm';
import VTKDataRefreshEmailForm from './VTKDataRefreshEmailForm';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3)
	},
	content: {
		marginTop: theme.spacing(3),
	},
	container: {
		marginTop: theme.spacing(3),
	}
}));

const StepIn = () => {
	const classes = useStyles();
    
	const [OptionSelector, setOptionSelector] = useState('invalid');

	const handleOptionSelectorChange = (method) => {
		setOptionSelector(method);
	};
    
	return (
		<Grid2 container spacing={2}>						
			<Grid2 item size={12}>
				<div className={clsx(classes.container)}>
					<OptionSelectorSelector onChange={handleOptionSelectorChange} value={OptionSelector} />
				</div>
			</Grid2>
			<Grid2 item size={12}>
				{OptionSelector !== 'invalid' && (
					<Card className={classes.content}>
						<CardContent>	
							<Grid2 item size={12}>
								<Typography align="center" variant="h4" gutterBottom component="div">
									{OptionSelector === '1' && "VTK Data Refresh"}
									{OptionSelector === '2' && "VTK Data Refresh From E-mail"}
									{OptionSelector === '3' && "S12 Thresholds History Update"}
									{OptionSelector === '4' && "Create XML Topology From FTP"}
								</Typography>
							</Grid2>
							<div className={clsx(classes.container)}>
								{OptionSelector === '1' && (<VTKDataRefreshForm />)}
								{OptionSelector === '2' && (<VTKDataRefreshEmailForm />)}
								{OptionSelector === '3' && (<S12ThresholdsHistoryUpdateForm />)}
								{OptionSelector === '4' && (<CreateXMLTopologyFromFTPForm />)}
							</div>
						</CardContent>	
					</Card>		
				)}					
			</Grid2>						
		</Grid2>
	);
};

export default StepIn;